<template>
  <div style="overflow: hidden; margin-top: -1.8rem">
    <div>
      <button class="btn btn-info m-2" @click="goBack">Back</button>

      <!-- view all agents if coming from /all-agents-->

      <button
        type="button"
        class="btn btn-success mr-2 custom-hover"
        style="background-color: #00c307; border-color: #00c307"
        @click="handleApproveKYC"
      >
        APPROVE KYC
      </button>

      <button
        class="btn m-2"
        @click="showModal = true"
        style="background-color: #e02b00; border: none"
      >
        REJECT KYC
      </button>

      <button class="btn btn-info m-2">REFRESH</button>
      <!-- <button class="btn btn-info m-2" @click="doActivate">
        Activate Agent
      </button> -->
      <div>
        <Modal
          :visible="showModal"
          :agentId="agent._id"
          @close="showModal = false"
        >
          <p class="head-txt">You are attempting to reject KYC submission</p>

          <label for="defaultReason" style="color: #9a9a9a; font-size: 16px"
            >Select Reason:</label
          >
          <select
            id="defaultReason"
            v-model="defaultReason"
            class="form-control op-border styled-dropdown"
          >
            <option disabled value="">Select</option>
            <option value="Blurred or Unclear Document">
              Blurred or Unclear Document
            </option>
            <option value="Expired Document">Expired Document</option>
            <option value="Document Mismatch">Document Mismatch</option>
          </select>

          <div class="button-container">
            <button
              class="btn btn-info mt-3 styled-button"
              style="border-radius: 18px"
              @click="handleRejectKYC"
            >
              SEND
            </button>
          </div>
          <button
            class="btn mt-3 to-kyc"
            style="
              border: none;
              background-color: transparent;
              color: #8c8ea7;
              font-size: 12px;
            "
            @click="showModal = false"
          >
            BACK TO KYC
          </button>
        </Modal>
      </div>
    </div>
    <card class="card">
      <h5 style="font-weight: 500; margin-bottom: 20px">Status</h5>
      <div :class="verificationStatusClass" class="verification-box">
        {{ verificationStatusText }}
      </div>

      <div
        class="accountType"
        v-if="agent.accountType === 'individual-account'"
      >
        <p>Account Type</p>
        <span>Individual</span>
      </div>

      <div class="tabs">
        <span
          v-if="agent.accountType == 'individual-account'"
          class="span-button"
          :class="{ active: visibleSection === 'business' }"
          @click="toggleSection('business')"
        >
          Personal Information
        </span>

        <span
          class="span-button"
          :class="{ active: visibleSection === 'kyc' }"
          @click="toggleSection('kyc')"
        >
          KYC Documents
        </span>

        <span
          v-if="agent.accountType == 'individual-account'"
          class="span-button"
          :class="{ active: visibleSection === 'amlCheck' }"
          @click="toggleSection('amlCheck')"
        >
          AML Report
        </span>
      </div>

      <div>
        <form @submit.prevent>
          <div
            v-if="
              agent.accountType === 'individual-account' &&
              visibleSection === 'business'
            "
          >
            <h4 v-if="agent.accountType == 'individual-account'">
              PERSONAL INFORMATION
            </h4>
            <h4 v-if="agent.accountType == 'business-account'">
              Business Information
            </h4>
            <div>
              <div class="row">
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="First Name"
                    placeholder="First Name"
                    :value="agent.firstName"
                    :disabled="true"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Middle Name"
                    placeholder="Middle Name"
                    :value="agent.middleName"
                    :disabled="true"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Last Name"
                    placeholder="Last Name"
                    v-model="agent.lastName"
                    :disabled="true"
                  ></fg-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Phone Number"
                    placeholder="Phone Number"
                    v-model="agent.phoneNumber"
                    :disabled="true"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    id="dateOfBirth"
                    label="Date of Birth"
                    placeholder="Date of Birth"
                    v-model="formattedDOB"
                    :disabled="true"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Gender"
                    placeholder="Gender"
                    v-model="agent.gender"
                    :disabled="true"
                  ></fg-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Email Address"
                    placeholder="Email"
                    v-model="agent.email"
                    :disabled="true"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Nationality"
                    placeholder="NATIONALITY"
                    v-model="agent.nationality"
                    :disabled="true"
                  ></fg-input>
                </div>

                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Bank Verification Number (BVN)"
                    placeholder="BVN"
                    v-model="maskedBVN"
                    :disabled="true"
                  ></fg-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="National Identification Number (NIN)"
                    placeholder="NIN"
                    v-model="maskedNin"
                    :disabled="true"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Residential Address"
                    placeholder="Address"
                    v-model="agent.address"
                    :disabled="true"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Landmark"
                    placeholder="Landmark"
                    v-model="agent.landmark"
                    :disabled="true"
                  ></fg-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="State of Origin"
                    placeholder="State"
                    v-model="agent.state"
                    :disabled="true"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="L.G.A of Origin"
                    placeholder="L.G.A"
                    v-model="agent.localGovernment"
                    :disabled="true"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Social Media platform"
                    placeholder="Socials"
                    v-model="agent.socialMedia.socialMediaPlatform"
                    :disabled="true"
                  ></fg-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <fg-input
                    type="text"
                    label="Social Media Handle"
                    placeholder="Socials"
                    v-model="agent.socialMedia.socialMediaHandle"
                    :disabled="true"
                  ></fg-input>
                </div>
                <div class="col-md-4">
                  <label> Merchant</label>
                  <select
                    class="form-control op-border"
                    id="rate-type"
                    v-model="agent.merchantId"
                    :disabled="true"
                  >
                    <option value="">Select Merchant</option>
                    <option
                      v-for="merchant in allMerchants"
                      :key="merchant.id"
                      :value="merchant._id"
                    >
                      {{ merchant.merchantName }}
                    </option>
                  </select>
                </div>
              </div>

              <h4>Sources of Income</h4>
              <div>
                <div class="row">
                  <div class="col-md-4">
                    <fg-input
                      type="text"
                      label="Source of Income"
                      placeholder="Source of Income"
                      v-model="(agent.sourcesOfIncome[0] || {}).occupation"
                      :disabled="true"
                    ></fg-input>
                  </div>

                  <div class="col-md-4">
                    <fg-input
                      type="text"
                      label="What is your annual income"
                      placeholder="What is your annual income"
                      v-model="(agent.sourcesOfIncome[0] || {}).annualIncome"
                      :disabled="true"
                    ></fg-input>
                  </div>

                  <div class="col-md-4">
                    <label>Other sources of income?</label>
                    <select
                      class="form-control op-border"
                      id="selectedOtherIncome"
                      v-model="selectedOtherIncome"
                      required
                      disabled
                    >
                      <option value="">Select Other sources of income</option>
                      <option
                        value="Yes"
                        v-if="agent.sourcesOfIncome.length > 1"
                      >
                        Yes
                      </option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>

                <div class="row" v-if="selectedOtherIncome === 'Yes'">
                  <div class="col-md-4">
                    <fg-input
                      type="text"
                      label="Other Occupation"
                      placeholder="Other Occupation"
                      v-model="(agent.sourcesOfIncome[1] || {}).occupation"
                      :disabled="true"
                    ></fg-input>
                  </div>

                  <div class="col-md-4">
                    <fg-input
                      type="text"
                      label="What is your annual income"
                      placeholder="What is your annual income"
                      v-model="(agent.sourcesOfIncome[1] || {}).annualIncome"
                      :disabled="true"
                    ></fg-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- UPLOAD KYC -->
          <div
            v-if="
              agent.accountType === 'individual-account' &&
              visibleSection == 'kyc'
            "
          >
            <div class="upload-kyc-section">
              <form @submit.prevent="submitKYC">
                <h4>KYC DOCUMENTS</h4>

                <h4>Uploaded Documents</h4>
                <div class="row">
                  <div class="col-md-4">
                    <label style="color: #000">NIN Image</label><br />
                    <template v-if="agent.idCardImgUrl">
                      <div
                        class="thumbnail"
                        @mouseover="showViewLink(agent.idCardImgUrl)"
                        @mouseleave="hideViewLink(agent.idCardImgUrl)"
                      >
                        <img
                          v-if="isImage(agent.idCardImgUrl)"
                          :src="agent.idCardImgUrl"
                          class="img-thumbnail"
                          alt="Id Card"
                          style="width: 100%"
                        />
                        <!-- Show PDF preview if it's a PDF -->
                        <div
                          v-else-if="isPDF(agent.idCardImgUrl)"
                          class="pdf-thumbnail"
                        >
                          <img
                            src="../assets/img/pdf.png"
                            class="pdf-icon"
                            alt="PDF File"
                            style="width: 100%"
                          />
                        </div>
                        <div
                          v-if="isViewLinkVisible(agent.idCardImgUrl)"
                          class="view-link"
                        >
                          <a
                            v-if="isPDF(agent.idCardImgUrl)"
                            :href="agent.idCardImgUrl"
                            target="_blank"
                            class="btn btn-info"
                          >
                            View
                          </a>
                          <a
                            v-else
                            @click="expandImage(agent.idCardImgUrl)"
                            class="btn btn-info"
                          >
                            View
                          </a>
                        </div>

                        <div
                          v-if="isExpanded(agent.idCardImgUrl)"
                          class="expanded-image"
                        >
                          <img
                            v-if="isImage(agent.idCardImgUrl)"
                            :src="agent.idCardImgUrl"
                            class="img-thumbnail"
                            alt="Id Card"
                          />

                          <div class="action-btns">
                            <button
                              class="btn btn-danger btn-sm"
                              @click="closeImage(agent.idCardImgUrl)"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div></div>
                    </template>
                  </div>

                  <div class="col-md-4">
                    <label style="color: #000">Proof of Address</label><br />
                    <template v-if="agent.addressImgUrl">
                      <div
                        class="thumbnail"
                        @mouseover="showViewLink(agent.addressImgUrl)"
                        @mouseleave="hideViewLink(agent.addressImgUrl)"
                      >
                        <img
                          v-if="isImage(agent.addressImgUrl)"
                          :src="agent.addressImgUrl"
                          class="img-thumbnail"
                          alt="Id Card"
                          style="width: 100%"
                        />
                        <!-- Show PDF preview if it's a PDF -->
                        <div
                          v-else-if="isPDF(agent.addressImgUrl)"
                          class="pdf-thumbnail"
                        >
                          <img
                            src="../assets/img/pdf.png"
                            class="pdf-icon"
                            alt="PDF File"
                            style="width: 100%"
                          />
                        </div>
                        <div
                          v-if="isViewLinkVisible(agent.addressImgUrl)"
                          class="view-link"
                        >
                          <a
                            v-if="isPDF(agent.addressImgUrl)"
                            :href="agent.addressImgUrl"
                            target="_blank"
                            class="btn btn-info"
                          >
                            View
                          </a>
                          <a
                            v-else
                            @click="expandImage(agent.addressImgUrl)"
                            class="btn btn-info"
                          >
                            View
                          </a>
                        </div>

                        <div
                          v-if="isExpanded(agent.addressImgUrl)"
                          class="expanded-image"
                        >
                          <img
                            v-if="isImage(agent.addressImgUrl)"
                            :src="agent.addressImgUrl"
                            class="img-thumbnail"
                            alt="Id Card"
                          />

                          <div class="action-btns">
                            <button
                              class="btn btn-danger btn-sm"
                              @click="closeImage(agent.addressImgUrl)"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div></div>
                    </template>
                  </div>

                  <div class="col-md-4">
                    <label style="color: #000">Image</label><br />
                    <template v-if="agent.profileImgUrl">
                      <div
                        class="thumbnail"
                        @mouseover="showViewLink(agent.profileImgUrl)"
                        @mouseleave="hideViewLink(agent.profileImgUrl)"
                      >
                        <img
                          v-if="isImage(agent.profileImgUrl)"
                          :src="agent.profileImgUrl"
                          class="img-thumbnail"
                          alt="Id Card"
                          style="width: 100%"
                        />
                        <!-- Show PDF preview if it's a PDF -->
                        <div
                          v-else-if="isPDF(agent.profileImgUrl)"
                          class="pdf-thumbnail"
                        >
                          <img
                            src="../assets/img/pdf.png"
                            class="pdf-icon"
                            alt="PDF File"
                            style="width: 100%"
                          />
                        </div>
                        <div
                          v-if="isViewLinkVisible(agent.profileImgUrl)"
                          class="view-link"
                        >
                          <a
                            v-if="isPDF(agent.profileImgUrl)"
                            :href="agent.profileImgUrl"
                            target="_blank"
                            class="btn btn-info"
                          >
                            View
                          </a>
                          <a
                            v-else
                            @click="expandImage(agent.profileImgUrl)"
                            class="btn btn-info"
                          >
                            View
                          </a>
                        </div>

                        <div
                          v-if="isExpanded(agent.profileImgUrl)"
                          class="expanded-image"
                        >
                          <img
                            v-if="isImage(agent.profileImgUrl)"
                            :src="agent.profileImgUrl"
                            class="img-thumbnail"
                            alt="Id Card"
                          />

                          <div class="action-btns">
                            <button
                              class="btn btn-danger btn-sm"
                              @click="closeImage(agent.profileImgUrl)"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div></div>
                    </template>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <!-- AML CHECK -->
          <div
            v-if="
              agent.accountType === 'individual-account' &&
              visibleSection == 'amlCheck'
            "
          >
            <h4>AML Report</h4>
            <AmlCheck :agentId="agent._id" />
          </div>

          <div class="clearfix"></div>
        </form>
      </div>
    </card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "../store/axios";
import moment from "moment";
import Swal from "sweetalert2";
import Modal from "../pages/Modals/Modal.vue";
import KYCUpload from "../components/KYCUpload.vue";
import AmlCheck from "./AmlCheck.vue";

export default {
  components: {
    Modal,
    KYCUpload,
    AmlCheck,
  },
  data() {
    return {
      defaultReason: "",
      rejectionReason: "",
      visibleSection: "business",
      showModal: false,
      uploadedDocs: {},

      agent: {
        bvn: "",
        businessName: "",
        email: "",
        address: "",
        phoneNumber: "",
        gender: "",
        lastName: "",
        firstName: "",
        dateOfBirth: "",
        country: "",
        state: "",
        localGovernment: "",
        merchantId: "",
        _id: "",
        agentId: "",
        idCardImg: null,
        addressImg: null,
        profileImgUrl: null,
        date: "",
        time: "",
        showModal: false,
        accountType: "",
        verifiedStatus: "pending",
        sourcesOfIncome: [],
      },
      // selectedOtherIncome: "No",
      allMerchants: [],
      loading: {
        show: false,
      },
      viewLinkVisible: {},
      expandedImages: [],
    };
  },

  computed: {
    maskedBVN() {
      return this.agent.bvnValid ? "True" : "False";
    },
    maskedNin() {
      return this.agent.nin ? "true" : "false";
    },
    ...mapState(["auth", "loading", "utils"]),
    formattedActivationDate() {
      const timestamp = moment(this.agent.activatedAt);
      return timestamp.format("DD-MM-YYYY HH:mm a");
    },
    formattedDOB: {
      get() {
        return moment(this.agent.dateOfBirth).format("DD-MM-YYYY");
      },
      set(newValue) {
        this.agent.dateOfBirth = moment(newValue).toISOString();
      },
    },

    verificationStatusClass() {
      const status = this.agent.verifiedStatus;
      switch (status) {
        case "pending":
          return "status-pending";
        case "verified":
          return "status-verified";
        case "rejected":
          return "status-rejected";
        case "partially_verified":
          return "status-partially-verified";
        default:
          return "status-unknown";
      }
    },

    verificationStatusText() {
      const status = this.agent.verifiedStatus;
      switch (status) {
        case "pending":
          return "Pending";
        case "verified":
          return "Verified";
        case "rejected":
          return "Rejected";
        case "partially_verified":
          return "Partially Verified";
        default:
          return "Unknown";
      }
    },

    selectedOtherIncome: {
      get() {
        return this.agent.sourcesOfIncome.length > 1 ? "Yes" : "No";
      },
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    masked(value) {
      if (!value || value.length <= 2) {
        return value;
      }

      const start = value.slice(0, Math.floor(value.length / 4));
      const end = value.slice(-Math.floor(value.length / 4));
      const middle = "******";

      return `${start}${middle}${end}`;
    },

    isImage(fileUrl) {
      return /\.(jpg|jpeg|png|gif|bmp)$/i.test(fileUrl);
    },
    isPDF(fileUrl) {
      return /\.pdf$/i.test(fileUrl);
    },

    ...mapActions([
      "getStates",
      "getLgas",
      "getCountries",
      "getMerchant",
      "updateAgent",
      "setNotification",
      "enableAgent",
      "disableAgent",
      "activateAgent",
    ]),
    submit() {
      this.$confirm("Update Agent?").then(() => {
        this.updateAgent(this.agent);
      });
    },
    addShareholder() {
      this.shareholders.push({
        firstName: "",
        lastName: "",
        email: "",
        dateOfBirth: "",
        gender: "",
        idCard: null,
        addressProof: null,
      });
    },
    removeShareholder(index) {
      this.shareholders.splice(index, 1);
    },
    addDirector() {
      this.directors.push({
        firstName: "",
        lastName: "",
        email: "",
        dateOfBirth: "",
        gender: "",
        idCard: null,
        addressProof: null,
      });
    },
    removeDirector(index) {
      this.directors.splice(index, 1);
    },
    addTrustee() {
      this.trustees.push({
        firstName: "",
        lastName: "",
        email: "",
        dateOfBirth: "",
        gender: "",
        idCard: null,
        addressProof: null,
      });
    },
    removeTrustee(index) {
      this.trustees.splice(index, 1);
    },
    handleDirectorIdCardUpload(event, index) {
      const file = event.target.files[0];
      this.$set(this.directors[index], "idCard", file);
    },
    handleDirectorAddressUpload(event, index) {
      const file = event.target.files[0];
      this.$set(this.directors[index], "addressProof", file);
    },
    fetchLgas() {
      this.agent.lga = "";
      this.getLgas(this.agent.state);
    },
    rejectKYC() {
      // Your rejection logic here
      console.log("KYC Rejected");
      this.showModal = false;
    },

    async handleApproveKYC() {
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/kyc/approve/${this.agent._id}`,
          null,
        );
        this.agent.verifiedStatus = "verified";
        // Show success notification
        Swal.fire({
          icon: "success",
          title: "KYC Approved",
          html: `You have approved the KYC submission for <b>${this.agent.firstName} ${this.agent.lastName}</b> with assigned Wallet ID: <b>${this.agent.walletId}</b>.`,
        });
      } catch (error) {
        // Handle error scenario
        console.error("Error approving KYC:", error);

        // Show error notification
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to approve KYC. Please try again later.",
        });
      }
    },

    async handleRejectKYC() {
      if (!this.defaultReason) {
        Swal.fire({
          icon: "error",
          title: "Validation Error",
          text: "Please select a default reason.",
        });
        return;
      }

      let payload = {
        reason: this.defaultReason,
      };

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/kyc/decline/${this.agent._id}`,
          payload,
        );
        this.agent.verifiedStatus = "rejected";

        // Show success notification
        Swal.fire({
          icon: "error",
          title: "KYC REQUEST REJECTED",
          html: `You have rejected the KYC submission for <b>${this.agent.firstName} ${this.agent.lastName}</b> with assigned Wallet ID: <b>${this.agent.walletId}</b>. A notification has been sent via email.`,
        });

        // Close modal after action is completed (if needed)
        this.showModal = false;
      } catch (error) {
        // Handle error scenario
        console.error("Error rejecting KYC:", error);

        // Show error notification
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to reject KYC. Please try again later.",
        });
      }
    },

    doDisable() {
      this.$confirm("Disable Agent! Are you sure?").then(() => {
        this.disableAgent({ id: this.agent._id });
        this.getAgent();
      });
    },
    doEnable() {
      this.$confirm("Enable Agent?").then(() => {
        this.enableAgent({ id: this.agent._id });
        this.getAgent();
      });
    },
    doActivate() {
      this.$confirm("Activate Agent?").then(() => {
        this.activateAgent({ id: this.agent._id });
        this.getAgent();
      });
    },
    async getAgent() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/agent/${this.$route.params.agentId}`,
        );
        const { agent } = res.data;
        this.agent = agent;
        console.log("aml data", this.agent.data);
      } catch (err) {
        const { data } = err.response.data;
        console.log(data);
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch Agent Data",
          });
        }
      }
    },
    async getMerchants() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/external-request/merchant/get-all-merchants`,
        );
        const { merchants } = res.data;
        this.allMerchants = merchants;
      } catch (err) {
        const { data } = err.response.data;

        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    submitKYC() {
      if (this.agent.idCardImg == null && this.agent.addressImgUrl == null) {
        this.$confirm("Upload all documents to proceed");
        return;
      }
      const formData = new FormData();
      formData.append("agentId", this.agent._id);
      formData.append("idCardImg", this.agent.idCardImg);
      formData.append("addressImg", this.agent.addressImg);
      this.loading.show = true;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/admin/upload-agent-documents`,
          formData,
        )
        .then((response) => {
          this.$confirm("KYC Submitted Successfully");
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading.show = false;
        });
    },
    showViewLink(imageUrl) {
      this.$set(this.viewLinkVisible, imageUrl, true);
    },
    hideViewLink(imageUrl) {
      this.$set(this.viewLinkVisible, imageUrl, false);
    },
    isViewLinkVisible(imageUrl) {
      return this.viewLinkVisible[imageUrl] || false;
    },
    expandImage(imageUrl) {
      if (!this.isExpanded(imageUrl)) {
        this.expandedImages.push(imageUrl);
      }
    },
    closeImage(imageUrl) {
      this.expandedImages = this.expandedImages.filter(
        (imgUrl) => imgUrl !== imageUrl,
      );
    },
    isExpanded(imageUrl) {
      return this.expandedImages.includes(imageUrl);
    },
    saveImage() {
      fetch(this.expandedImages)
        .then((response) => response.blob())
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          // Create a temporary link element
          const link = document.createElement("a");
          link.href = url;
          const filename = `${this.agent.firstName}-${this.agent.lastName}-kyc.jpg`;
          link.download = filename;
          link.click();
          URL.revokeObjectURL(url); // Clean up the temporary URL
        })
        .catch((error) => {
          console.error("Error downloading image:", error);
        });
    },
    accountTypeDisplay() {
      if (this.agent.accountType == "individual-account") {
        return "Individual Account";
      } else {
        return "Business Account";
      }
    },
    toggleSection(section) {
      this.visibleSection = section;
    },
  },
  async mounted() {
    // this.getCountries();
    // this.getStates();
    this.getMerchants();
    // this.$route.params.agentId
    await this.getAgent();

    this.$nextTick(() => {
      this.selectedOtherIncome =
        this.agent.sourcesOfIncome.length > 1 ? "Yes" : "No";
    });
  },
};
</script>
<style>
.upload-kyc-section {
  padding: 10px;
}
.thumbnail {
  position: relative;
  display: inline-block;
  border-radius: 10px;
}
.thumbnail img {
  width: 50%;
  height: auto;
  /* border-radius: 10px; */
}

.view-link {
  position: absolute;
  top: 50%;
  left: 15%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.3s ease;
  cursor: pointer;
}

.view-link a {
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff !important;
  text-decoration: none;
}
.thumbnail:hover .overlay {
  opacity: 1;
}
.thumbnail:hover .view-link {
  opacity: 1;
}

.action-btns {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.action-btns button {
  margin: 5px;
  padding: 8px 10px;
}

.custom-hover :hover {
  background-color: #00c307;
  border: #00c307;
}
.btn-black {
  background-color: black;
  color: white;
}
.tabs {
  border-bottom: 1px solid rgb(154, 154, 154);
  display: flex;
  align-items: center;
  gap: 1rem;
}
.span-button {
  background: none;
  border: none;
  padding: 0.5rem 1rem;
  margin: 0;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.3s ease;
  color: #000;
  position: relative;
}

.head-txt {
  color: black;
  font-weight: 700;
}

.span-button.active {
  color: #1eb75b;
  border-bottom: 1px solid #1eb75b;
  font-weight: 500;
}

.button-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.styled-button {
  width: 162px;
  height: 41px;
  padding: 8px 0 0 0;
  gap: 8px;
  border-radius: 100px 0 100px 0;
  opacity: 0;
}
.verification-box {
  width: 206px;
  height: 40px;
  padding: 8px 5px;
  border-radius: 4px;
  display: flex;
  justify-content: left;
  align-items: left;
  color: #fff;
  font-weight: bold;
  opacity: 1;
  font-size: 16px;
  margin-top: -10px;
}

.status-pending {
  background-color: #f8be29;
}

.status-verified {
  background-color: green;
}

.status-rejected {
  background-color: rgb(224, 43, 0);
}

.status-partially-verified {
  background-color: #b5af03;
}

.accountType {
  display: flex;
  flex-direction: column;
  margin: 40px 0 24px 0;
}

.accountType p {
  margin: 0;
  color: #000;
  margin-bottom: 8px;
  font-weight: 500;
}

.accountType span {
  background: #f4f3ef;
  padding: 12px;
  width: 100%;
  max-width: 250px;
  border-radius: 4px;
  color: #000;
  font-weight: 500;
  font-size: 16px;
}

.red-btn {
  background: #e02b00;
  border: none;
}
</style>
